import React from "react";
import { withRouter } from "react-router-dom";
import { get, filter, includes } from "lodash";

import AddDriveInOutDialog from "./AddDriveInOutDialog";

import { driveInOut } from "../../../constants/reducers";
import { LOG_EVENT_GROUP_TYPES } from "../../../constants/logEventGroupTypes";
import { getLov } from "../../../utils/lov";

const AddDriveInOutFromMenu = (props) => {
  const [open, setOpen] = React.useState(true);
  const [lov, setLov] = React.useState({});

  const eventGroupType = get(
    filter(
      get(lov, ["eventGroupTypes"]),
      (item) => get(item, ["id"]) === parseInt(props.eventGroupType)
    ),
    [0]
  );

  React.useEffect(() => {
    const fetchEventGroupTypes = async () => {
      try {
        let eventGroupTypes = await getLov("eventGroupTypes");
        eventGroupTypes = filter(eventGroupTypes, (t) =>
          includes(get(LOG_EVENT_GROUP_TYPES, driveInOut), t.id)
        );
        setLov({
          eventGroupTypes,
        });
      } catch (e) {
        console.log(e);
      }
    };
    fetchEventGroupTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeDialog = () => {
    setOpen(false);
    props.history.goBack();
    document.getElementById("root").focus();
  };

  return (
    <AddDriveInOutDialog
      open={open}
      closeDialog={closeDialog}
      eventGroupType={eventGroupType}
    />
  );
};

export default withRouter(AddDriveInOutFromMenu);
